import { render, staticRenderFns } from "./AddClawbackModal.vue?vue&type=template&id=60d0ae04&scoped=true"
import script from "./AddClawbackModal.vue?vue&type=script&lang=js"
export * from "./AddClawbackModal.vue?vue&type=script&lang=js"
import style0 from "./AddClawbackModal.vue?vue&type=style&index=0&id=60d0ae04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d0ae04",
  null
  
)

export default component.exports